<ng-container *ngIf="initialContent">
  <ng-container *ngIf="isAllowed && editMode; else readOnlyTemplate">
    <app-ck-editor
      #resourceEditor
      [version]="'full'"
      [initialData]="initialContent"
      (contentChange)="emitAutosave($event)"
      [channelId]="'resource_content.' + docId"></app-ck-editor>
  </ng-container>
  <ng-template #readOnlyTemplate>
    <div class="overflow-auto resource-content">
      <app-safehtml
        [html]="initialContent"
        [classList]="['fr-view']"></app-safehtml>
    </div>
  </ng-template>
</ng-container>
